import { useEffect, useState } from 'react'

import { GETAllVariables } from '@types'

import { EVENT_NAME, LocalEventBus, subscribe, unsubscribe } from '../../../events'

type UseSubscribeVariablesChangeParams = {
  windowVariables: GETAllVariables
  event: EVENT_NAME
  localEventBus: LocalEventBus | undefined
}

export const useSubscribeVariablesChange = ({
  windowVariables,
  event,
  localEventBus,
}: UseSubscribeVariablesChangeParams) => {
  const [updatedVariables, setUpdatedVariables] = useState<GETAllVariables>(windowVariables)

  // Обработчик события изменения переменной
  const handleEventVariableChange = (data: CustomEvent) => {
    setUpdatedVariables(prevVariables => {
      const indexReplaceVariable = prevVariables.findIndex(
        variable => variable.id === data.detail.id
      )

      if (indexReplaceVariable < 0) {
        return [...prevVariables, data.detail]
      } else {
        const updatedVariables = [...prevVariables]
        updatedVariables[indexReplaceVariable] = data.detail

        return updatedVariables
      }
    })
  }

  // useEffect отслеживающий изменение переменных формы. Не добавляет переменные, если они уже существуют в состоянии updatedVariables
  useEffect(() => {
    setUpdatedVariables(prevVariables => {
      const filteredArray = windowVariables.filter(variable => {
        return !updatedVariables.some(oldVariable => {
          return oldVariable.id === variable.id
        })
      })

      return [...filteredArray, ...prevVariables]
    })
  }, [windowVariables])

  // useEffect добавляющий подписку на ивент (Локальный который передали в пропсах или глобальный от document)
  useEffect(() => {
    if (localEventBus) {
      localEventBus.subscribe(event, handleEventVariableChange)
    } else {
      subscribe(event, handleEventVariableChange)
    }

    return () => {
      if (localEventBus) {
        localEventBus.unsubscribe(event, handleEventVariableChange)
      } else {
        unsubscribe(event, handleEventVariableChange)
      }
    }
  }, [])

  return { updatedVariables }
}
